import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from '../common/Footer';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex flex-1">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 p-4 md:p-6 w-full md:ml-0">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
